/**
 * VideoJS
 * show button 2 minutes after video starts
 */
if ($('#proPlantVSL').length) {
    videojs('proPlantVSL').ready(function () {
        this.on('timeupdate', function () {
            if (this.currentTime() >= (60 * 1) || this.currentTime() == this.duration()) {
                $('.vslSection .btn').removeClass('invisible');
            }
            // console.log(this.currentTime());
        })
    });
};

/**
 * Handle Video instances Play/Pause
 */
// Create array for player IDs
let players = [];

// Determine the available player IDs
for (let i = 0; i < Object.keys(videojs.players).length; i++) {
    // Assign the player name to setPlayer
    var setPlayer = Object.keys(videojs.players)[i];

    // Define the ready event for the player
    videojs.getPlayer(setPlayer).ready(function () {
        // Assign this player to a variable
        let myPlayer = this;

        //- Assign Slick controls to a variable
        let slickArrow = $('.slick-arrow');
        let slickDots = $('.slick-dots li');

        // Assign and event listener for play event
        myPlayer.on("play", onPlay);

        slickArrow.on("click", onPlay);
        slickDots.on("click", onPlay);

        // Push the player to the players array
        players.push(myPlayer);
    });
}

// Handle all players' play event 
function onPlay(e) {
    // Determine which player the event is coming from
    var id = e.target.id;

    // Loop through the array of players
    for (let x = 0; x < players.length; x++) {
        // Get the player(s) that did not trigger the play event
        if (players[x].id() != id) {
            // Pause the other player(s)
            videojs(players[x].id()).pause();
        }
    }
}

function vslSectionHeight(parentId) {	
    let vslSectionHeight = Math.floor($(parentId).outerHeight());
    document.documentElement.style.setProperty('--vslSectionHeight', vslSectionHeight + 'px');
}

if ($('#socialProofBanner + #testimonials').length) {
    let testimonialsVideo = $('#testimonials .video');

    vslSectionHeight(testimonialsVideo);

    //- seTimeout for window resizing
    let resizeTimer;

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            vslSectionHeight(testimonialsVideo);
        }, 250);

    });
}

if ($('#socialProofBanner + #watch').length) {
    let vslSection = $('#watch .video');

    vslSectionHeight(vslSection);

    //- seTimeout for window resizing
    let resizeTimer;

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            vslSectionHeight(vslSection);
        }, 250);

    });
}